import Link from 'next/link'

import { PageTypeSuffix } from '@/constants'
import type { Post } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import ImageOptimize from '../ImageOptimize'

interface BlogCardType {
  post: Post
  imageWidth?: number
  imageHeight?: number
  type?: number
}

const BlogCard = ({ post, imageWidth = 400, imageHeight = 226, type = 1 }: BlogCardType) => {
  return (
    <div className={` w-full cursor-pointer `}>
      <Link
        href={`/${getTranslate(post.slugs.value)}${post.slugs.postfix}${PageTypeSuffix.POST}`}
        className={`relative block w-full overflow-hidden rounded-lg pt-[56.25%]`}
      >
        <ImageOptimize
          width={imageWidth}
          height={imageHeight}
          className={`absolute left-0 top-0 block h-full w-full object-cover`}
          alt={getTranslate(post?.title) || ''}
          src={post?.images[0]}
          thumbnail
        />
      </Link>
      <div className={`w-ull relative mt-2 flex flex-wrap items-start`}>
        <Link
          href={`/${getTranslate(post.slugs.value)}${post.slugs.postfix}${PageTypeSuffix.POST}`}
          className={`flex flex-col flex-wrap`}
        >
          <h5
            className={` mb-1.5 w-full overflow-hidden text-dark-900 ${
              type === 3 ? 'text-xl font-bold leading-snug' : ' h-10 text-base font-medium leading-5'
            }`}
          >
            {getTranslate(post?.title)}
          </h5>
          {type === 3 && (
            <p
              className='text-dark-700 line-clamp-3 w-full text-base'
              dangerouslySetInnerHTML={{ __html: getTranslate(post?.description) }}
            />
          )}
        </Link>
      </div>
    </div>
  )
}

export default BlogCard
